import merge from 'lodash/merge';

const initialState = {
  key: '',
  orderedBy: {},
  fabricators: {},
  features: {},
  stones: {},
  masterStones: {},
  stoneSupplierStones: {},
  fabricatorFeatures: {}
};

export default function entities(state = initialState, action) {
  if (action.payload && action.payload.entities) {
    const key = action.payload.result;
    return merge({}, state, { key, ...action.payload.entities });
  }

  return state;
}
